// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LexxyMarkdownPasteController from "./lexxy_markdown_paste_controller"
application.register("lexxy-markdown-paste", LexxyMarkdownPasteController)

import MarkdownToggleController from "./markdown_toggle_controller"
application.register("markdown-toggle", MarkdownToggleController)

import NavigationMenuController from "./navigation_menu_controller"
application.register("navigation-menu", NavigationMenuController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import TomselectorController from "./tomselector_controller"
application.register("tomselector", TomselectorController)

import UppyImageFieldController from "./uppy_image_field_controller"
application.register("uppy-image-field", UppyImageFieldController)

import UppyMultiFileUploadController from "./uppy_multi_file_upload_controller"
application.register("uppy-multi-file-upload", UppyMultiFileUploadController)

import UppySingleFileUploadController from "./uppy_single_file_upload_controller"
application.register("uppy-single-file-upload", UppySingleFileUploadController)
